<template>
  <div class="userDialogbox" @click="handleClose" v-if="show">
    <div class="dialog">
      <div class="header">温馨提示</div>
      <div class="tit">请使用Safari浏览器进行下载</div>
      <div class="link">{{ currentLink }}</div>
      <button
        ref="copyBtn"
        class="copybtn"
        :data-clipboard-text="currentLink"
        @click.stop="handleCopy"
      >
        {{ copyText }}
      </button>
    </div>
  </div>
</template>

<script>
import ClipboardJS from "clipboard";

export default {
  data() {
    return {
      show: true,
      dev: "",
      currentLink: "",
      copyText: "复制链接",
    };
  },
  methods: {
    handleClose() {
      this.show = false;
    },
    handleOpen() {
      this.show = true;
    },
    handleCopy() {},
    isOtherBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      const isMobile = /mobile|android|iphone|ipad|phone/i.test(ua);
      const isChrome = /chrome|crios/i.test(ua) && !/edge|edg/i.test(ua);
      const isSafari = /safari/i.test(ua) && !/chrome|crios/i.test(ua);
      return isMobile && !isChrome && !isSafari;
    },
  },
  created() {
    this.currentLink = window.location.href;
  },
  mounted() {
    this.show = this.isOtherBrowser();
    this.clipboard = new ClipboardJS(this.$refs.copyBtn);
    this.clipboard.on("success", () => {
      this.copyText = "复制成功";
      setTimeout(() => {
        this.show = false;
      }, 1000);
    });
    this.clipboard.on("error", () => {
      this.copyText = "复制失败";
    });
  },
  beforeDestroy() {
    this.clipboard.destroy(); // 清理实例
  },
};
</script>
<style lang="scss">
.userDialogbox {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.38);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog {
    width: 85%;
    background: #fff;
    padding: 15px 25px 20px;
    border-radius: 12px;
    text-align: center;

    .header {
      color: #000;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
    }

    .tit {
      color: #000;
      text-align: center;
      font-size: 16px;
      font-weight: normal;
      margin-top: 30px;
    }

    .link {
      color: #000;
      text-align: center;
      font-size: 16px;
      font-weight: normal;
      margin-top: 4px;
    }

    .copybtn {
      border: 0;
      background: #ff2442;
      width: 65%;
      padding: 10px;
      border-radius: 20px;
      color: #fff;
      margin-top: 30px;
    }
  }
}
</style>
